import type { CSSProperties, ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from 'styled-components';

import { Drawer } from '#src/atoms/layout/Drawer/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { CloseButton } from '#src/components/dialog/CloseButton/index.tsx';
import { useIsTabletAndAbove } from '#src/hooks/device/useIsTabletAndAbove.ts';
import { glossary } from '#src/lib/glossary.ts';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

const StyledDrawer = styled(Drawer)`
  background: var(--c-black);
  padding: var(--double-unit);

  @media ${tabletAndAbove} {
    width: 320px;
  }
`;

const DrawerContent = styled(Vertical)`
  padding: var(--double-unit) 0;
`;
const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  align-items: center;
`;

type Props = Pick<ComponentProps<typeof Drawer>, 'children' | 'open'> & {
  onClose: () => void;
};

export const FiltersDrawer = ({ children, onClose, ...rest }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  return (
    <StyledDrawer
      onClose={onClose}
      fullScreen={!isTabletAndAbove}
      onBackdropClick={onClose}
      {...rest}
    >
      <Header>
        <LabelM className="text-center" bold>
          <FormattedMessage {...glossary.filterBy} />
        </LabelM>
        <CloseButton onClose={onClose} />
      </Header>
      <DrawerContent
        style={{ '--label-padding': 'var(--half-unit) 0' } as CSSProperties}
      >
        {children}
      </DrawerContent>
    </StyledDrawer>
  );
};
